import Link from './Link';
import { cEl } from '../../util';
import { PATH_CONTACT, PATH_HOME, PATH_LEARN, PATH_TEST } from '../path';

function Navigation() {
    const navigation = cEl('nav');
    navigation.classList.add('main-nav');
    const border = cEl('div');
    border.classList.add('thin-border');

    const leftNav = cEl('div');
    leftNav.classList.add('left-nav');

    const homeLink = Link({ innerHTML: '병원 서비스 로봇', href: PATH_HOME });

    leftNav.appendChild(homeLink);

    const rightNav = cEl('div');
    rightNav.classList.add('right-nav');

    const learnLink = Link({
        innerHTML: '배우기',
        href: PATH_LEARN,
    });
    const testLink = Link({
        innerHTML: '테스트',
        href: PATH_TEST,
    });
    const contactLink = Link({
        innerHTML: '문의하기',
        href: PATH_CONTACT,
    });

    rightNav.append(learnLink, testLink, contactLink);

    navigation.append(leftNav, rightNav, border);

    return navigation;
}

export default Navigation;
